import React from "react";
import { FaDownload } from "react-icons/fa6";
import Link from "next/link";
export default function D01({ downlItem }) {
  return (
    <section>
      {/* {JSON.stringify(downlItem)} */}
      <div className="container  m-auto pt-[10px] pb-[1rem] px-[1rem] sm:px-[2rem] lg:px-[3rem]">
        {downlItem?.advanceData?.data?.length && (
          <div className="grid grid-rows">
            <div className="grid grid-cols-12 gap-[1rem]">
              {downlItem.advanceData.data.map((item, index) => (
                <div className="col-span-12  sm:col-span-12  md:col-span-6  lg:col-span-6 xl:col-span-6">
                  <div className="flex gap-[1rem] justify-between bg-[#15803d] rounded-[8px] pt-[8px] pb-[10px] px-[10px]">
                    {item?.title && (
                      <div>
                        <h3 className="text-[white] text-[16px] sm:text-[18px] font-semibold">
                          {item.title}
                        </h3>
                      </div>
                    )}
                    {item?.fileUrl && (
                      <div>
                        <Link href={item.fileUrl} className="text-[white] ">
                          <FaDownload className="text-[20px]  mt-[3px]" />
                        </Link>
                      </div>
                    )}
                  </div>
                </div>
              ))}
            </div>
          </div>
        )}
      </div>
    </section>
  );
}
